

<div class="container">
  <div class="wrapper">
    <div class="content">
      <div class="item">
        <h1>Awaiting data from connected IoT devices...</h1>
        <p>Learn more about us <a href="https://www.assetto.biz/#iotintegrated" target="_blank">Assetto</a></p>
      </div>
    </div>
  </div>
</div>

